import { gql } from '@apollo/client';

export const GET_PROPOSAL_SNAPSHOT = gql`
  query ProposalSnapshot($id: ID) {
    proposal(id: $id) {
      snapshot: createdSnapshot
    }
  }
`;
